import React, { useState } from "react";
import UserActions from "../reducer";
import { useDispatch, useSelector } from "react-redux";

export const useDemoDataToggle = () => {
  const dispatch = useDispatch();
  const { is_show_demo_data } = useSelector(
    (state) => state.auth.userInfo,
  );
  const { demoDataShownToggleLoading: loading } = useSelector(
    (state) => state.user,
  );

  const toggleDemoData = () => {
    dispatch(
      UserActions.demoDataToggleRequest({
        isShown: !is_show_demo_data,
      }),
    );
  };

  return { isShowDemoData: is_show_demo_data, toggleDemoData, loading };
};
